import React, { useContext } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'

import { useNavigate, useParams } from 'react-router-dom';
import ArrowDownRight from '../../comonents/Icons/Arrow-down-right';
import ArrowUpRight from '../../comonents/Icons/Arrow-up-right';
// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'
import Timer from '../../comonents/Timer'
export default function Game2Calculation() {
    const navigate = useNavigate();

    let { did } = useParams();
    did = did || 0;

    function toSubmit() {
        // navigate('/game2help')
    }
    function toHelp() {
        navigate('/game2help')
    }
    return (
        <div>
            <TitleBar backLastPage="" lastPageName="" />

            <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem' }}>
                <div className='text-center'>
                    <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>Calculation of Hash 12 </p></b>
                </div>
                <div>

                    <div className='d-flex justify-content-between' style={{ paddingTop: '1rem' }} >
                        <input type='button' className=' calculation_help fw-bold' value={"Help ?"} onClick={e => toHelp()} />
                        <div className=' text-center col-4'>
                            <p className='time_border'>
                                <Timer />
                            </p>

                        </div>

                    </div>
                </div>
                <div>
                    Detail of the Previous Hash Values<br /><br />
                    Hash 1:<br /><br />
                    Hash2:<br /><br />
                </div>
                <br />
                <br />
                <div className='CalculationInput_div'>
                    <div>
                        Hash 34 Value<br />
                        <input type="number" className='Calculation_hash_input'></input>
                    </div>
                    <br />
                    <div>
                        Nonce<br />
                        <input type="number" className='Calculation_hash_input'></input>
                    </div>
                </div>
                {/* <div className='d-flex justify-content-end' style={{ paddingTop: '1rem' }} >
                    <input type='button' className=' calculation_submit fw-bold' value={"Submit"} onClick={e => toSubmit()} />
                </div> */}
            </div>
            <div style={{ paddingTop: '2rem' }}>
                <div className='Btns_Back'>
                    <input type="button" className='Btn_Back' value='Submit'></input>
                </div>
                <div className='Btns_Back'>
                    <input type="button" className='Btn_Back' value='Back' onClick={e => navigate(-1)} />
                </div>
            </div>
        </div>

    )
}